function getHeight() {
	var myHeight = 0;
	if( typeof( window.innerHeight ) == 'number' ) {
	//Non-IE
	myHeight = window.innerHeight;
	} else if( document.documentElement && ( document.documentElement.clientHeight ) ) {
	//IE 6+ in 'standards compliant mode'
	myHeight = document.documentElement.clientHeight;
	} else if( document.body && ( document.body.clientHeight ) ) {
	//IE 4 compatible
	myHeight = document.body.clientHeight;
	}
	return [myHeight];
}

function getWidth() {
    var myWidth = 0;
    if (typeof(window.innerWidth) == 'number') {
        //Non-IE
        myWidth = window.innerWidth;
    } else if (document.documentElement && (document.documentElement.clientWidth)) {
        //IE 6+ in 'standards compliant mode'
        myWidth = document.documentElement.clientWidth;
    } else if (document.body && (document.body.clientWidth)) {
        //IE 4 compatible
        myWidth = document.body.clientWidth;
    }
    return [myWidth];
}

$(window).resize(function() {
	var current_width = getWidth();
	var current_height = getHeight();
	
	var slider_width = (current_width * 0.58);
	
	$('.mobile_menu').height( current_height );
	$('.slider_content').height( slider_width );
	
});

jQuery(document).ready(function() {

	var current_width = getWidth();
	var current_height = getHeight();
	
	$('.mobile_menu').height( current_height );
	
	/* normal subnav functions */
	$('.menu .menu-item-has-children').mouseover(function() {
		$(this).find('.submenu_wrap').stop().fadeIn();
	});
	
	$('.menu .menu-item-has-children').mouseleave(function() {
		$(this).find('.submenu_wrap').stop().fadeOut();
	});

	
	// mobile menu functions
	$('.menuicon_mobile').click(function() {
		$('.mobile_menu').slideDown();
	});
	
	$('.mobile_menu_close').click(function() {
		$('.mobile_menu').slideUp('fast');
	});
	
	//add submenu trigger item
	$( ".mobile_menu .menu-item-has-children" ).append( "<div class='submenu_trigger'>&nbsp;</div>" );
	
	
	$( ".mobile_menu .menu-item-has-children" ).hasClass('current-menu-item', function(){ 
			//$(this).find('.submenu_wrap').addClass('open');
	});
	
	$('.submenu_trigger').click(function() {

		$(this).toggleClass('open');	
		$(this).toggleClass('closed');	
		
		//first close all open submenu items
		$('.submenu_wrap.open').slideToggle('fast',  function() {
				$(this).removeClass('open');	
				$(this).addClass('closed');
				$(this).next('.submenu_trigger').removeClass('open');
				$(this).next('.submenu_trigger').addClass('closed');
		});
		
		//then open current item
		$(this).parent().find('.submenu_wrap.closed').slideToggle('fast', function() {
				$(this).toggleClass('open');	
				$(this).toggleClass('closed');	
		});
	});

	/* add container element to sub-menu items */
	$( ".sub-menu" ).wrap( "<div class='submenu_wrap closed'><div class='submenu_wrap_inner width_max'></div></div>" );

    // init Isotope
    var $grid = $('.grid').isotope({
        itemSelector: '.element-item',
        layoutMode: 'fitRows',
        getSortData: {
            name: '.name',
            symbol: '.symbol',
            number: '.number parseInt',
            category: '[data-category]',
            weight: function( itemElem ) {
                var weight = $( itemElem ).find('.weight').text();
                return parseFloat( weight.replace( /[\(\)]/g, '') );
            }
        }
    });

// filter functions
    var filterFns = {
        // show if number is greater than 50
        numberGreaterThan50: function() {
            var number = $(this).find('.number').text();
            return parseInt( number, 10 ) > 50;
        },
        // show if name ends with -ium
        ium: function() {
            var name = $(this).find('.name').text();
            return name.match( /ium$/ );
        }
    };

// bind filter button click
    $('#filters').on( 'click', 'button', function() {
        var filterValue = $( this ).attr('data-filter');
        // use filterFn if matches value
        filterValue = filterFns[ filterValue ] || filterValue;
        $grid.isotope({ filter: filterValue });
    });

// bind sort button click
    $('#sorts').on( 'click', 'button', function() {
        var sortByValue = $(this).attr('data-sort-by');
        $grid.isotope({ sortBy: sortByValue });
    });

// change is-checked class on buttons
    $('.button-group').each( function( i, buttonGroup ) {
        var $buttonGroup = $( buttonGroup );
        $buttonGroup.on( 'click', 'button', function() {
            $buttonGroup.find('.is-checked').removeClass('is-checked');
            $( this ).addClass('is-checked');
        });
    });



});
